import { AppText, FlexRow, Button } from "src/style";
import "./index.scss";
import { useState, useContext } from "react";
import { Modal } from "../Modal";
import VisibilityContext from "src/provider/state-manager/visibilityProvider";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import { AiOutlineClose, AiOutlineCheck } from "react-icons/ai";

const AddUserModal = () => {
  const { setModal, visibility } = useContext(VisibilityContext);
  const { setSubmitUser, info } = useContext(AppInfoContext);
  const closeModal = () => {
    setModal({ key: "showAddUserModal", value: false });
  };
  const handleConfirm = () => {
    setSubmitUser(!info.submitUser);
    setModal({ key: "showAddUserModal", value: false });
  };
  return (
    <Modal
      open={visibility.showAddUserModal}
      cancel={closeModal}
      className="add-user-modal"
      isOnMenu
    >
      <div className="confirmation">
        <AppText color="black" fontWeight="600" textSize="1.6" align="center">
          Are you sure you want to create this user?
        </AppText>
      </div>
      <FlexRow justifyContent="space-between" className="btn-container">
        <Button
          hoverColor="#A77B37"
          onClick={closeModal}
          className="add-user-btn cancel"
        >
          <AiOutlineClose size={17} />
          Cancel
        </Button>
        <Button
          hoverBgColor="#fff"
          hoverColor="#A77B37"
          borderColor="#A77B37"
          className="add-user-btn confirm"
          onClick={handleConfirm}
        >
          <AiOutlineCheck size={17} /> Confirm
        </Button>
      </FlexRow>
    </Modal>
  );
};
export default AddUserModal;
